// extracted by mini-css-extract-plugin
export default {"gosuslugiButton":"oHVVt","hugeIcon":"D8DIw","compactIcon":"GM0x3"};